// extracted by mini-css-extract-plugin
module.exports = {"root":"FadeInSection_root__qOCXQ","is_visible":"FadeInSection_is_visible__nEVXu","moveUp":"FadeInSection_moveUp__MBods"};